import { Controller } from "@hotwired/stimulus"

export class InstantSearchController extends Controller<HTMLFormElement> {
  search(_event: CustomEvent) {
    this.element.requestSubmit()
  }
}
